import { render, staticRenderFns } from "./TemperatureTargets.vue?vue&type=template&id=95e9abd2&scoped=true&"
import script from "./TemperatureTargets.vue?vue&type=script&lang=ts&"
export * from "./TemperatureTargets.vue?vue&type=script&lang=ts&"
import style0 from "./TemperatureTargets.vue?vue&type=style&index=0&id=95e9abd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e9abd2",
  null
  
)

export default component.exports